"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusSourceMixin = exports.fontSmoothingMixin = exports.placeholderMixin = exports.ifDesktopWindow = exports.ifMobile = exports.ifDesktop = exports.isolateMixin = exports.middleMixin = void 0;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var middleMixin = {
  '&:before': {
    display: 'inline-block',
    height: '100%',
    verticalAlign: 'middle',
    content: '""',
    width: 0
  },
  '& > *': {
    verticalAlign: 'middle'
  }
};
exports.middleMixin = middleMixin;
var isolateMixin = {
  borderCollapse: 'separate',
  borderSpacing: 0,
  borderRadius: 0,
  captionSide: 'top',
  cursor: 'auto',
  direction: 'ltr',
  emptyCells: 'show',
  fontFamily: 'inherit',
  fontSize: 'medium',
  fontStyle: 'normal',
  fontVariant: 'normal',
  fontWeight: 'normal',
  fontStretch: 'normal',
  lineHeight: 'normal',
  verticalAlign: 'baseline',
  hyphens: 'none',
  letterSpacing: 'normal',
  listStyle: 'disc outside none',
  tabSize: '8',
  textAlign: 'left',
  textAlignLast: 'auto',
  textIndent: '0',
  textShadow: 'none',
  textTransform: 'none',
  visibility: 'visible',
  whiteSpace: 'normal',
  widows: '2',
  wordSpacing: 'normal',
  padding: 0,
  margin: 0
};
exports.isolateMixin = isolateMixin;

var responsiveFactory = function responsiveFactory(rule) {
  return function (options) {
    return (0, _defineProperty2.default)({}, rule, options);
  };
};

var ifDesktop = responsiveFactory('@media (min-device-width: 768px)');
exports.ifDesktop = ifDesktop;
var ifMobile = responsiveFactory('@media (max-device-width: 767px)');
exports.ifMobile = ifMobile;
var ifDesktopWindow = responsiveFactory('@media (min-width: 768px)');
exports.ifDesktopWindow = ifDesktopWindow;
var pseudoSelectors = ['::-webkit-input-placeholder', '::-moz-placeholder', ':-moz-placeholder', ':-ms-input-placeholder', '::placeholder'];

var placeholderMixin = function placeholderMixin(selector, style) {
  return pseudoSelectors.reduce(function (result, pseudo) {
    return (0, _extends3.default)({}, result, (0, _defineProperty2.default)({}, "".concat(selector).concat(pseudo), style));
  }, {});
};

exports.placeholderMixin = placeholderMixin;
var fontSmoothingMixin = {
  '-webkit-font-smoothing': 'antialiased',
  '-moz-osx-font-smoothing': 'grayscale'
};
/**
 * Applying styles on elements depending on focus event source type
 * @param {string} sourceType Other/pointer
 * @param {string} selector CSS-selector
 * @param {string} declaration CSS-declaration
 */

exports.fontSmoothingMixin = fontSmoothingMixin;

var focusSourceMixin = function focusSourceMixin() {
  var sourceType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'other';
  var selector = arguments.length > 1 ? arguments[1] : undefined;
  var declaration = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _defineProperty2.default)({}, "html[data-focus-source=\"".concat(sourceType, "\"] ").concat(selector), declaration);
};

exports.focusSourceMixin = focusSourceMixin;